import OrderForwardListResponse, {
  OrderForwardListResponseDataItem,
  OrderForwardListResponseDataItemConsumer,
  OrderForwardListResponseDataItemProducer,
} from "../../../api/raily/order-forward/list/order-forward-list.response";
import OrderForwardList, {
  OrderForwardListItem,
  OrderForwardListItemConsumer,
  OrderForwardListItemProducer,
} from "./order-forward-list";

const createDataItemConsumer = (
  consumer: OrderForwardListResponseDataItemConsumer,
): OrderForwardListItemConsumer => {
  return {
    id: consumer.id,
    name: consumer.name,
  };
};

const createDataItemProducer = (
  producer: OrderForwardListResponseDataItemProducer,
): OrderForwardListItemProducer => {
  return {
    id: producer.id,
    name: producer.name,
  };
};

const createDataItem = (
  dataItem: OrderForwardListResponseDataItem,
): OrderForwardListItem => {
  return {
    consumer: createDataItemConsumer(dataItem.consumer),
    driver: dataItem.driver,
    externalId: dataItem.externalId,
    forwardingTime: dataItem.forwardingTime,
    humanId: dataItem.humanId,
    id: dataItem.id,
    passengers: dataItem.passengers,
    producer: createDataItemProducer(dataItem.producer),
    readOnly: dataItem.readOnly,
    rideAddresses: dataItem.rideAddresses,
    startTime: dataItem.startTime,
  };
};

const createData = (
  data: OrderForwardListResponseDataItem[],
): OrderForwardListItem[] => {
  return data.map(createDataItem);
};

const create = (response: OrderForwardListResponse): OrderForwardList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const orderForwardListFactory = {
  create,
};

export default orderForwardListFactory;
